import i18n from './src/i18n';
export * as config from './src/config/global';
var translate = i18n.t.bind(i18n);
export { translate };
export default i18n;
